import { coreApi } from '.';
import type { AssistantResponse, CreateAssistantReq, UpdateAssistantReq } from 'types';
import { TAG_TYPES } from 'types/services';

export const assistantsService = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssistants: builder.query<AssistantResponse[], void>({
      query: () => ({
        url: 'Assistants',
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.ASSISTANTS],
    }),
    getAssistantById: builder.query<AssistantResponse, string>({
      query: (id) => ({
        url: `Assistants/${id}`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.ASSISTANTS],
    }),
    createAssistant: builder.mutation<AssistantResponse, CreateAssistantReq>({
      query: (data) => ({
        url: 'Assistants',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.ASSISTANTS],
    }),
    updateAssistant: builder.mutation<AssistantResponse, UpdateAssistantReq>({
      query: (data) => ({
        url: `Assistants/${data.id}`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: data.data,
      }),
      invalidatesTags: [TAG_TYPES.ASSISTANTS],
    }),
    deleteAssistant: builder.mutation<void, string>({
      query: (id) => ({
        url: `Assistants/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG_TYPES.ASSISTANTS],
    }),
  }),
});

export const { useGetAssistantsQuery, useGetAssistantByIdQuery, useCreateAssistantMutation, useUpdateAssistantMutation, useDeleteAssistantMutation } =
  assistantsService;
